"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var comment_1 = __importDefault(require("./sub/comment"));
var video_link_1 = __importDefault(require("./sub/video-link"));
var logo_1 = __importDefault(require("./sub/logo"));
var title_1 = __importDefault(require("./sub/title"));
var advertising_1 = __importDefault(require("./sub/advertising"));
var video_1 = __importDefault(require("./sub/video"));
var NativeVideo = function (_a) {
    var adObj = _a.adObj, native = _a.adObj.native, mobile = _a.mobile, white = _a.white;
    return (React.createElement(video_link_1.default, { adObj: adObj, className: "mod flex", style: {
            height: mobile ? '85vw' : '100%',
            width: '100%',
        }, preventDefaultPredecate: predecate },
        React.createElement("div", { className: "inner r-pal", style: {
                height: '100%',
            } },
            React.createElement("div", { style: {
                    borderRadius: '8px',
                    backgroundColor: '#f6f8fb',
                    height: '100%',
                    position: 'relative',
                } },
                React.createElement(comment_1.default, { placement: "native-video", adObj: adObj }),
                React.createElement("div", { style: {
                        borderTopRightRadius: '8px',
                        borderTopLeftRadius: '8px',
                        overflow: 'hidden',
                        position: 'relative',
                    } },
                    React.createElement(video_1.default, { native: native, id: adObj.targetId }),
                    React.createElement(advertising_1.default, { marking: "sponsor", adObj: adObj, style: {
                            borderTopRightRadius: '8px',
                            borderBottomLeftRadius: '8px',
                            height: '30px',
                            backgroundColor: white
                                ? 'rgba(71, 68, 69, 0.8)'
                                : 'rgba(248, 248, 248, 0.8)',
                            position: 'absolute',
                            right: '0',
                            top: '0',
                            paddingTop: '4px',
                            paddingRight: '27px',
                            paddingLeft: '11px',
                        }, white: white })),
                React.createElement("div", { style: {
                        height: '25%',
                        width: '100%',
                        padding: mobile ? '8px' : '16px',
                        overflow: 'hidden',
                    } },
                    React.createElement(title_1.default, { h: 3, native: native, id: "native-add__title", style: {
                            width: '75%',
                            fontSize: mobile ? '22px' : '28px',
                            fontWeight: 300,
                            fontStyle: 'normal',
                            fontStretch: 'normal',
                            lineHeight: '1.21',
                            letterSpacing: 'normal',
                            color: '#474445',
                            margin: '0px',
                            float: 'left',
                            hyphens: 'none',
                            msHyphens: 'none',
                            WebkitHyphens: 'none',
                        } }),
                    React.createElement(logo_1.default, { native: native, style: {
                            float: 'right',
                            height: '65px',
                        } }))))));
};
exports.default = NativeVideo;
function isVideoplayer(element) {
    if (element.classList && element.classList.value)
        // @ts-ignore
        return ' ' + element.classList.value.indexOf('jw-') > -1;
    return false;
}
function isButton(element) {
    return element.getAttribute('role') === 'button';
}
function isSlider(element) {
    return element.classList.contains('jw-slider-volume');
}
function predecate(target) {
    if (target instanceof HTMLElement) {
        return isVideoplayer(target) && (isButton(target) || isSlider(target));
    }
    return false;
}
